import {useContext} from "react";

// import {ProjectContext} from "../contexts/ProjectContext";
import {CompanyType} from "../models/company";
import {UserContext} from "../contexts/UserContext";
import BuilderHome from "../components/builder/BuilderHome";
import DeveloperHome from "../components/developer/DeveloperHome";


export default function HomePage() {
    const userContext = useContext(UserContext);
    // console.log(userContext)
    if (userContext?.company_type === CompanyType.developer) {
        return <DeveloperHome/>
    } else if (userContext?.company_type === CompanyType.builder) {
        return <BuilderHome/>
    }
    return (<div> err </div>)
}